"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const auth = (sdk) => {
    const { sdkConfig: { url, tokenProvider }, defaultVersion, } = sdk;
    const httpClient = sdk.httpClient;
    return {
        keycloakLogin: async (code) => {
            const endpoint = `${url}/${defaultVersion}/auth/keycloak`;
            const response = await httpClient.post(endpoint, { auth: false, payload: { code } });
            if (tokenProvider === null || tokenProvider === void 0 ? void 0 : tokenProvider.setToken) {
                tokenProvider.setToken(response.data);
            }
            return response.data;
        },
        facebookLogin: async (credentials) => {
            const endpoint = `${url}/${defaultVersion}/auth/facebook`;
            const response = await httpClient.post(endpoint, { auth: false, payload: credentials });
            if (tokenProvider === null || tokenProvider === void 0 ? void 0 : tokenProvider.setToken) {
                tokenProvider.setToken(response.data);
            }
            return response.data;
        },
        login: async (credentials) => {
            const endpoint = `${url}/${defaultVersion}/auth/login`;
            const response = await httpClient.post(endpoint, { auth: false, payload: credentials });
            if (tokenProvider === null || tokenProvider === void 0 ? void 0 : tokenProvider.setToken) {
                tokenProvider.setToken(response.data);
            }
            return response.data;
        },
        refresh: async (refreshToken) => {
            const endpoint = `${url}/${defaultVersion}/auth/refresh`;
            const response = await httpClient.post(endpoint, { auth: false, payload: { refreshToken } });
            if (tokenProvider === null || tokenProvider === void 0 ? void 0 : tokenProvider.setToken) {
                tokenProvider.setToken(response.data);
            }
            return response.data;
        },
        logout: async () => {
            const endpoint = `${url}/${defaultVersion}/auth/logout`;
            const response = await httpClient.post(endpoint).finally(() => {
                if (tokenProvider === null || tokenProvider === void 0 ? void 0 : tokenProvider.deleteToken) {
                    tokenProvider.deleteToken();
                }
            });
            return response.data;
        },
        validateCaptcha: async (payload) => {
            const endpoint = `${url}/${defaultVersion}/auth/captcha`;
            const reponse = await httpClient.post(endpoint, { payload });
            return reponse.data;
        },
    };
};
exports.default = auth;
